(() => {
  const initializeCharts = () => {
    const drawer = document.getElementById('Product-Drawer');
    if (!drawer?.classList.contains('active')) return;
    if (!drawer.querySelector('#KiwiSizingChart:not(.kiwiSizingLoaded)')) return;

    if (typeof window.ks?.loadSizing === 'function') {
      window.ks.loadSizing({ productData: {}, options: {} });
      return;
    }

    let script = document.querySelector('script[src*="kiwiSizing/plugin/SizingPlugin"]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://app.kiwisizing.com/web/js/dist/kiwiSizing/plugin/SizingPlugin.prod.js?v=340';
      script.async = true;
      script.addEventListener('load', initializeCharts, { once: true });
      document.head.appendChild(script);
    } else {
      script.removeEventListener('load', initializeCharts);
      script.addEventListener('load', initializeCharts, { once: true });
    }
  };

  document.addEventListener('quick-view:open', initializeCharts);
})();
